import { render, staticRenderFns } from "./topSalesByDealer.vue?vue&type=template&id=30c53cea&"
import script from "./topSalesByDealer.vue?vue&type=script&lang=js&"
export * from "./topSalesByDealer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports